var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.81728 15.0603V15.0582L2.81727 4.97C2.81727 3.88188 3.69916 3 4.78727 3H18.8505C19.9381 3.00178 20.8186 3.88469 20.8173 4.97278V4.974L20.8173 15.0582L20.8173 15.0601C20.8194 16.1478 19.9398 17.0315 18.8518 17.0342H11.0533H10.649L10.3583 17.3152L6.81728 20.7379V18.0342V17.0342H5.81728H4.78728H4.78252C3.69469 17.0315 2.81502 16.1478 2.81728 15.0603Z",
    stroke: "red",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10.0044C14.9971 9.45249 15.4426 9.00297 15.9946 9.00001C16.5469 8.99706 16.997 9.44206 17 9.99393C17.0047 10.5447 16.5617 10.9951 16.0104 11C15.4529 11.0012 15.0028 10.5562 15 10.0044Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 9.99046C11.0049 9.4386 11.4564 8.99535 12.0087 9.00004C12.5596 9.0049 13.0029 9.45389 13 10.0044C12.9923 10.5559 12.5433 10.9991 11.9913 11C11.439 10.9934 10.9952 10.5421 11 9.99046Z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00002 10.007C6.9962 9.45462 7.44089 9.00385 7.99323 9.00002C8.54557 8.99637 8.99617 9.44088 9 9.99304C9 10 9 10.007 9 10.0139C8.99426 10.5588 8.55183 10.9981 8.00697 11C7.45463 11.0036 7.00385 10.5591 7.00002 10.007Z",
    fill: "red"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsChat);
export default __webpack_public_path__ + "static/media/icons-chat.b3425a04b0c97d144aac2a00e1c5b14a.svg";
export { ForwardRef as ReactComponent };